import React from "react";
import "../component/staffTable.css";

const StaffTable = ({
  page,
  staffs,
  onEditStaffClicked,
  onDeleteStaffClicked,
}) => {
  const editStaff = (staff) => {
    console.log(staff);
    onEditStaffClicked(staff);
  };

  const deleteStaff = (staff) => {
    onDeleteStaffClicked(staff);
  };

  return (
    <div className="staff-table-container">
      <table className="staff-table">
        <thead>
          <tr>
            <th width="100px">No</th>
            <th>Nama Staff</th>
            <th>Username Staff</th>
            <th>Gaji Staff</th>
            <th>Bonus Staff</th>
            <th>Staff Role</th>
            <th width="150px">Actions</th>
          </tr>
        </thead>
        <tbody>
          {staffs.length > 0 ? (
            staffs.map((staff, index) => (
              <tr key={index}>
                <td>{(page - 1) * 10 + index + 1}</td>
                <td>{staff.staff_name}</td>
                <td>{staff.staff_username}</td>
                <td>{staff.staff_salary}</td>
                <td>{staff.staff_bonus}</td>
                <td>{staff.staff_system_role}</td>
                <td>
                  <button
                    className="edit-doctor-specialist-button"
                    onClick={() => {
                      editStaff(staff);
                    }}
                  >
                    Edit
                  </button>
                  <button
                    className="delete-doctor-specialist-button"
                    onClick={() => {
                      deleteStaff(staff);
                    }}
                  >
                    Hapus
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" style={{ textAlign: "center" }}>
                Data tidak tersedia
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default StaffTable;
